import React from 'react';
import { useNavigate } from 'react-router-dom';


const OrgChartSection = () => {
    const navigate = useNavigate();
      const handleRecruit = () => navigate('/access-recruit');

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        {/* Left Content */}
        <div style={styles.leftContent}>
          <h1 style={styles.heading}>
            See how Humanex helps you solve your unique business needs at scale.
          </h1>
          <button style={styles.demoButton} onClick={handleRecruit}>
            REQUEST A DEMO
          </button>
        </div>

        {/* Right Image */}
        <div style={styles.rightImage}>
          <img 
            src="/images/Benifit_Cta_1.png"
            alt="Organization Chart"
            style={styles.image}
          />
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    background: 'linear-gradient(135deg, #FC5151 0%, #D14246 100%)',
    padding: '10px 34px',
    fontFamily: "'Raleway', -apple-system, BlinkMacSystemFont, sans-serif",
    borderRadius: '10px',
    height: '300px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '40px'
  },
  container: {
    maxWidth: '1440px',
    margin: '0 auto',
    marginTop: '20px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '80px',
    alignItems: 'center',
    width: '100%',
  },
  leftContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    paddingRight: '40px',
  },
  heading: {
    fontSize: '40px',
    fontWeight: '700',
    color: '#ffffff',
    lineHeight: '1.2',
    margin: 0,
    letterSpacing: '-0.5px',
    textAlign: 'justify'
  },
  demoButton: {
    alignSelf: 'flex-start',
    padding: '18px 48px',
    background: '#ffffff',
    color: '#c62828',
    border: 'none',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '800',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    letterSpacing: '1px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
    outline: 'none',
  },
  rightImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    right: '-60px',
    top: '34%',
    transform: 'translateY(-50%)',
  },
  image: {
    width: '100%',
    maxWidth: '650px',
    display: 'block',
    filter: 'drop-shadow(0 20px 40px rgba(0, 0, 0, 0.15))',
  },
};

// Add hover styles
const styleTag = document.createElement('style');
styleTag.textContent = `
  button:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2) !important;
  }
  
  button:active {
    transform: translateY(-1px);
  }

  @media (max-width: 1024px) {
    div[style*="gridTemplateColumns"] {
      grid-template-columns: 1fr !important;
      gap: 50px !important;
    }
    
    h1 {
      font-size: 44px !important;
    }
    
    div[style*="paddingRight"] {
      padding-right: 0 !important;
    }
  }

  @media (max-width: 768px) {
    section {
      padding: 60px 20px !important;
    }
    
    h1 {
      font-size: 36px !important;
    }
    
    button {
      width: 100%;
      text-align: center;
    }
  }

  @media (max-width: 480px) {
    h1 {
      font-size: 32px !important;
    }
    
    button {
      padding: 16px 36px !important;
      font-size: 14px !important;
    }
  }
`;
document.head.appendChild(styleTag);

export default OrgChartSection;